<div class="cmp-card-simple card-wrapper pb-0 rounded border border-light badge-main">
  <div class="card shadow-sm rounded" style="background-color: #f6fbff;">
    <div class="card-body">
      <!-- Title card -->
      <div *ngIf="confezione.denominazionePackage">
        <h4 class="card-title text-primary h6 mb-3">
          {{ confezione.denominazionePackage }}
        </h4>
      </div>
      <!-- Fine Title card -->

      <!-- Info confezione -->
      <div class="row text-black">
        <!-- Codice AIC -->
        <div class="col-sm-12 col-md-6 mb-3">
          <div *ngIf="confezione.denominazionePackage">
            <span
              i18n="
                titolo codice AIC|pagina dettaglio forma dosaggio dettaglio
                confezione"
              class="fw-bold small ms-1"
              >AIC</span
            >
            <br />

            <div class="avatar avatar-blue-custom size-sm me-1 mt-1">
              <span
                class="fw-bold small"
                i18n="
                  Label per piano terapeutico|Icone dettaglio medicinale"
                >AIC</span
              >
            </div>

            <span class="small">{{ confezione.aic }}</span>
          </div>
        </div>
        <!--Fine  Codice AIC -->

        <!-- Data autorizzazione -->
        <div class="col-sm-12 col-md-6 mb-3">
          <div *ngIf="confezione.dataAutorizzazione">
            <span
              i18n="
                titolo autorizzazione|pagina dettaglio forma dosaggio dettaglio
                confezione@@details-page.confezione-card-data-text
              "
              class="fw-bold small"
              >Data autorizzazione
            </span>
            <br />
            <svg class="icon icon-sm">
              <use href="assets/icons/sprites.svg#it-calendar"></use>
            </svg>
            <span class="small">
              {{ confezione.dataAutorizzazione | date : "dd/MM/yyyy" }}
            </span>
            
          </div>
        </div>
        <!-- Fine Data autorizzazione -->

        <!-- Classe di rimborsabilità -->
        <div class="col-sm-12 col-md-6 mb-3">
          <div *ngIf="confezione.descrizioneRimborsabilita">
            <span
              class="fw-bold small"
              i18n="
                titolo classe di rimborsabilita|pagina dettaglio forma dosaggio
                dettaglio confezione
              "
              >Classe di rimborsabilità</span
            ><br />

            <div class="d-flex align-items-center ">
              <div
                class="avatar size-sm me-1 {{
                  getIconClass(confezione.classeRimborsabilita)
                }}"
                *ngIf="confezione.classeRimborsabilita"
              >
                <span class="small" aria-hidden="true">{{
                  confezione.classeRimborsabilita
                }}</span>
              </div>
              <span class="small mt-1">
                {{ confezione.descrizioneRimborsabilita | titlecase }}
              </span>
            </div>
          </div>
          <!-- Fine Classe di rimborsabilità -->

          <!-- Regime fornitura -->
          <div
            [ngClass]="confezione.descrizioneRimborsabilita ? 'mt-4' : 'mt-0'"
          >
          
            <span
              class="fw-bold small"
              i18n="
                titolo regime di fornitura|pagina dettaglio forma dosaggio
                dettaglio confezione
              "
              >Regime di Fornitura</span
            >
            <br />
            <div class="d-flex align-items-center mt-1">
              <div
                class="avatar size-sm me-1 {{
                  getIconClass(confezione.classeFornitura)
                }}"
                *ngIf="confezione.classeFornitura"
              >
                <span class="small" aria-hidden="true">{{
                  confezione.classeFornitura
                }}</span>
              </div>
              <span class="small" *ngFor="let d of confezione.descrizioneRf">
                {{ d }}
              </span>
            </div>
          </div>
          <!-- Fine Regime fornitura -->

          <!-- Piano terapeutico -->
          <div class="my-4" 
          [ngClass]="confezione.pianoTerapeutico ? 'mt-4' : 'mt-0'" >
            <div class="d-flex align-items-center" *ngIf="confezione.pianoTerapeutico">
              <div
                [ngClass]="
                  !confezione.pianoTerapeutico
                    ? 'avatar-white-purple-custom'
                    : 'avatar-full-purple-custom'
                "
                class="avatar size-sm me-1 mt-1"
              >
                <span
                  class="fw-bold small"
                  i18n="
                    Label per piano terapeutico|Icone dettaglio medicinale
                    @@confezione.label-piano-terapeutico"
                  >PT</span
                >
              </div>
              <span
                class="small"
                i18n="
                  {response.data.pianoTerapeutico === 1 ?'piano terapeutico
                  no|Icone dettaglio medicinale' : 'piano terapeutico no|Icone
                  dettaglio medicinale' }
                  @@confezione.result-text-piano-terapeutico"
                >{{
                  confezione.pianoTerapeutico
                    ? "E' previsto Piano Terapeutico"
                    : "Non è previsto Piano Terapeutico"
                }}</span
              >
            </div>
          </div>
          <!-- Fine piano  terapeutico -->
        </div>
        <!-- Fine info confezione -->

        <!-- Informazioni Carenza -->
        <div
          *ngIf="confezione.carente"
          class="row text-black red-border rounded mb-5"
        >
         <!-- Motivazione -->
        
          <div *ngIf="confezione.carenzaMotivazione">
           <!--<span
              class="fw-bold small"
              i18n="
                titolo motivazione|pagina dettaglio forma dosaggio dettaglio
                confezione @@confezione.title-motivazione"
              >Motivazione</span
            >
            <br />-->
            <span class="small text-danger " style="font-weight: bold;">
              {{ confezione.carenzaMotivazione }}
            </span>
          
          <!-- Fine Motivazione -->
        </div>
          <!-- Data inizio carenza -->
          <div class="d-flex justify-content-between">
            <div *ngIf="confezione.carenzaInizio">
              <span
                class="fw-bold small"
                i18n="
                  titolo data inizio carenza|pagina dettaglio forma dosaggio
                  dettaglio confezione @@confezione.title-inizio-carenza"
                >Inizio carenza</span
              >
              <br />
              <svg class="icon icon-sm">
                <use href="assets/icons/sprites.svg#it-calendar"></use>
              </svg>
              <span class="small">
                {{ confezione.carenzaInizio | date : "dd/MM/yyyy" }}
              </span>
            </div>
        <!-- Fine Data inizio carenza -->

        <!-- Data fine presunta -->
          <div *ngIf="confezione.carenzaFinePresunta">
            <span
              class="fw-bold small"
              i18n="
                titolo data fine presunta carenza|pagina dettaglio forma
                dosaggio dettaglio confezione @@confezione.title-fine-presunta"
              >Fine presunta</span
            >
            <br />
            <svg class="icon icon-sm">
              <use href="assets/icons/sprites.svg#it-calendar"></use>
            </svg>
            <span class="small">
              {{ confezione.carenzaFinePresunta | date : "dd/MM/yyyy" }}
            </span>
          </div>
        </div>
         <div class="row" style=" padding-left: 2px;">
          <div>
          <span
              *ngIf="confezione.carente"
              class=" badge badge-custom rounded-pill bg-danger text-white   fw-bold small" 
         
              i18n="
                messaggio carenza|card risultato ricerca
                @@confezione.text-carenza"
              >IN CARENZA</span>
              </div>
      </div>
    </div>
          <!-- Fine Data fine presunta -->

         
        </div>

        <div class="row mb-2">
          <!-- Badges -->
          <div class="badge-container">
            <!-- In Carenza -->
            
            
            <!-- Fine In carenza -->

            <!-- Stato Amministrativo -->
            <span
              *ngIf="!(confezione.statoAmministrativo === 'A')"
              class="badge rounded-pill  text-black me-1 bg-warning" style="background-color: #ffc107!important;"
              >{{ confezione.descrizioneStatoAmministrativo }}</span
            >
            <!-- Fine Stato Amministrativo -->

            <!-- Non in commercio -->
            <span
              class="badge rounded-pill bg-success text-white" i18n="messaggio in commercio|card risultato ricerca@@confezione.text-commercio"
              *ngIf="confezione.flagCommercio === 1"
              >IN COMMERCIO</span
            >
            
            <!-- Fine Non in commercio -->
          </div>
          <!-- Fine Badges -->
        </div>

        <!-- Badge carenza old -->
        <!-- <div [hidden]="!confezione.carente" class="div-carenza rounded">
      <img
        alt="In Carenza"
        i18n-alt="alet icona carenza|card risultato ricerca"
        class="mx-1"
        src="assets/images/ic_carenza.png"
        style="width: 16px; height: 16px"
      />
      <span
        style="vertical-align: middle"
        i18n="messaggio carenza|card risultato ricerca@@confezione.text-carenza"
        >IN CARENZA</span
      >
    </div> -->
        <!-- Badge fine carenza -->
      </div>
    </div>
  </div>

